export const TEST_IDS = {
  // Navigation
  navLogo: 'nav-logo',
  navMethodLink: 'nav-method-link',
  navCredentialsLink: 'nav-credentials-link',
  navTestimonialsLink: 'nav-testimonials-link',
  navProcessLink: 'nav-process-link',
  navFaqLink: 'nav-faq-link',
  navCtaBtn: 'nav-cta-btn',
  audioToggleBtn: 'audio-toggle-btn',
  mobileMenuBtn: 'mobile-menu-btn',
  mobileMenu: 'mobile-menu',

  // Hero
  heroSection: 'hero-section',
  heroOverline: 'hero-overline',
  heroHeadline: 'hero-headline',
  heroSubheadline: 'hero-subheadline',
  heroCtaPrimary: 'hero-cta-primary',
  heroCtaSecondary: 'hero-cta-secondary',
  heroSocialProof: 'hero-social-proof',
  heroImage: 'hero-image',

  // Agitation
  agitationSection: 'agitation-section',
  agitationHeadline: 'agitation-headline',

  // Method
  methodSection: 'method-section',
  methodHeadline: 'method-headline',
  methodStep1: 'method-step-connecting',
  methodStep2: 'method-step-revealing',
  methodStep3: 'method-step-landing',

  // Authority
  authoritySection: 'authority-section',
  authorityHeadline: 'authority-headline',
  authorityImage: 'authority-image',

  // Testimonials
  testimonialsSection: 'testimonials-section',
  testimonialsHeadline: 'testimonials-headline',

  // Process
  processSection: 'process-section',
  processHeadline: 'process-headline',

  // FAQ
  faqSection: 'faq-section',
  faqHeadline: 'faq-headline',
  faqAccordion: 'faq-accordion',

  // CTA
  ctaSection: 'cta-section',
  ctaHeadline: 'cta-headline',
  ctaButton: 'cta-button',

  // Footer
  footerSection: 'footer-section',
  footerLinkedin: 'footer-linkedin',
  footerEmail: 'footer-email',
};

export const HOME = {
  emergentLink: 'emergent-link',
};
